import script from "./DropdownSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownSearch.vue?vue&type=script&setup=true&lang=js"

import "./DropdownSearch.vue?vue&type=style&index=0&id=3ac8f593&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac8f593"]])

export default __exports__